var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWater = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1666 6.66669H15.8333C14.4516 6.66669 13.3333 5.54835 13.3333 4.16669C13.3333 2.78502 14.4516 1.66669 15.8333 1.66669H24.1666C25.5483 1.66669 26.6666 2.78502 26.6666 4.16669C26.6666 5.54835 25.5483 6.66669 24.1666 6.66669Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M28.3334 15.0566C28.3334 13.9333 28.0001 12.835 27.3784 11.9L25.0001 8.33331V6.51331C24.7384 6.60664 24.4601 6.66664 24.1667 6.66664H15.8334C15.5401 6.66664 15.2617 6.60664 15.0001 6.51331V8.33331L12.6217 11.9C12.0001 12.835 11.6667 13.9333 11.6667 15.0566V15.9766C11.6667 17.485 12.2667 18.9333 13.3334 20C12.2667 21.0666 11.6667 22.515 11.6667 24.0233V33.3333C11.6667 36.095 13.9051 38.3333 16.6667 38.3333H23.3334C26.0951 38.3333 28.3334 36.095 28.3334 33.3333V24.0233C28.3334 22.515 27.7334 21.0666 26.6667 20C27.7334 18.9333 28.3334 17.485 28.3334 15.9766V15.0566Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWater, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/water.4359cf63.svg";
export { ForwardRef as ReactComponent };